// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7539ff8a","380":"b165718b","809":"0558621c","839":"7efba932","929":"07de38e8","992":"7354c26b"}[chunkId] + ".chunk.js";
};